import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconApplicantsSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M8.00016 1.33334C4.32016 1.33334 1.3335 4.32001 1.3335 8.00001C1.3335 11.68 4.32016 14.6667 8.00016 14.6667C11.6802 14.6667 14.6668 11.68 14.6668 8.00001C14.6668 4.32001 11.6802 1.33334 8.00016 1.33334ZM12.2402 11.22C11.2868 10.06 8.9735 9.66668 8.00016 9.66668C7.02683 9.66668 4.7135 10.06 3.76016 11.22C3.08016 10.3267 2.66683 9.21334 2.66683 8.00001C2.66683 5.06001 5.06016 2.66668 8.00016 2.66668C10.9402 2.66668 13.3335 5.06001 13.3335 8.00001C13.3335 9.21334 12.9202 10.3267 12.2402 11.22ZM8.00016 4.00001C6.70683 4.00001 5.66683 5.04001 5.66683 6.33334C5.66683 7.62668 6.70683 8.66668 8.00016 8.66668C9.2935 8.66668 10.3335 7.62668 10.3335 6.33334C10.3335 5.04001 9.2935 4.00001 8.00016 4.00001Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
